import React, { FC, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Review } from 'Containers/Reviews/components/TrackList/props'
import { getFilteredArr } from 'Shared/components/InfinityScrollWrapper/helpers'
import InfinityLoader from '../infinityLoader'
import { LoaderWrapper } from './styled'
import { InfinityScrollWrapperPropsType } from './types'

const InfinityScrollWrapper: FC<InfinityScrollWrapperPropsType> = ({
  children,
  dataLength,
  isLoading,
  next,
  hasMore,
}) => (
  <InfiniteScroll
    dataLength={dataLength}
    next={next}
    hasMore={hasMore}
    loader={
      <LoaderWrapper>
        <InfinityLoader isLoading={isLoading} />
      </LoaderWrapper>
    }
  >
    {children}
  </InfiniteScroll>
)

export default InfinityScrollWrapper
